// Copyright (c) 2017 Deere & Company

import WipClaims, {getDefaultState as getWipClaimsDefaultState} from '@deere/cps-it.warranty-model-factory/lib/wip-claims';
import WipOpenPips, {getDefaultState as getWipOpenPipsDefaultState} from '@deere/cps-it.warranty-model-factory/lib/open-pips-summary';
import WipPips, {getDefaultState as getWipPipsDefaultState} from '@deere/cps-it.warranty-model-factory/lib/wip-pips';
import WipProductTracking, {getDefaultState as getWipProductTrackingDefaultState} from '@deere/cps-it.warranty-model-factory/lib/wip-product-tracking';
import WipReturnParts, {getDefaultState as getWipReturnPartsDefaultState} from '@deere/cps-it.warranty-model-factory/lib/wip-return-parts';
import t from 'tcomb';

const WorkInProgress = t.struct({
    claims: WipClaims,
    openPips: WipOpenPips,
    pips: WipPips,
    productTracking: WipProductTracking,
    returnParts: WipReturnParts
}, 'WorkInProgress');

export const getDefaultState = () =>
    new WorkInProgress({
        claims: getWipClaimsDefaultState(),
        openPips: getWipOpenPipsDefaultState(),
        pips: getWipPipsDefaultState(),
        productTracking: getWipProductTrackingDefaultState(),
        returnParts: getWipReturnPartsDefaultState()
    });

export default WorkInProgress;



// WEBPACK FOOTER //
// ./src/home-page/state/wip.js